
import { useState, useEffect } from 'react';
import { DataScroller } from 'primereact/datascroller';
import moment from 'moment';
import { useLocation } from 'react-router-dom';
import { getAllCustomerInfo } from '../../service/allCustomerInfo.service';
import { responseCardSelected, returnCardInfo } from '../../utilities/common.utilities';
import { ScrollPanel } from 'primereact/scrollpanel';
import { useConnectivity } from '../../context/connectivityContext';
import './yourRewards.css'


type YourRewards = {
award: {
    awardsManager: string;
    code: string;
    contributePoints: number;
    description: string;
    ecommerceVisible: boolean;
    id: number;
    idAwardsManager: number;
    moneyContribute: number;
    name: string;
    pickupInAllGroupStores: boolean;
    pickupInStore: boolean;
    picture: string;
    points: number;
    requireNextOrder: boolean;
    shipmentAtHome: boolean;
}
awardsDeliveryType: string;
awardsQuantity: number;
bookedInStore: {
    id: string; 
    name: string;
}
bookedWithContribute: boolean;
bookingDate: string;
catalog: {
    id: number;
    name:string;
}
contribute: number;
id: number;
points: number;
receivedDate: string;
receivedInStore: {
    id: string;
    name: string;
}
senderPlatformType: string;
}



export default function YouRewardsComponent() {
    const [bookingAwards, setBookingAwards] = useState<any[]>([]);
    const [receivedAwards, setReceivedAwards] = useState<any[]>([]);
    const [cardData, setCardData] = useState<responseCardSelected>();
    const [viewReceivedAwards, setViewReceivedAwards] = useState<boolean>(false);
    const [viewBookingAwards, setViewBookingAwards] = useState<boolean>(true);
    const [rowsReceivedAwards, setRowsReceivedAwards] = useState<number>(3);

    // Variabile utilizzata per sapere se ci sono errori nella ricezione dei premi come l' assenza di connessione.
    // Utilizzata per distinguere sul template, se la mancanza di premi è dovuta ad errore oppure effettivamente non c'è ne sono.
    const [errorGetRewards, seterrorGetRewards] = useState<boolean>(false);
    const { isOnline } = useConnectivity();

    const getYourRewards = () => {
        returnCardInfo().then(cardData => {
            setCardData(cardData);
            getAllCustomerInfo(cardData.groupCode, cardData.storeCode, cardData.card).then(allCustomerInfo => {

                seterrorGetRewards(false);

                let resultBookingAwards:YourRewards[] = []; 
                    if(allCustomerInfo?.bookings?.bookedAwards?.length > 0){
                        resultBookingAwards = allCustomerInfo.bookings.bookedAwards;
                    } else { 
                        resultBookingAwards = [];
                    }
                    setBookingAwards(resultBookingAwards);

                let resultReceivedAwards:YourRewards[] = [];
                    if(allCustomerInfo?.bookings?.receivedAwards?.length > 0){
                        resultReceivedAwards = allCustomerInfo.bookings.receivedAwards;
                    } else { 
                        resultReceivedAwards = [];
                    }
                    setReceivedAwards(resultReceivedAwards);
    
                if(!allCustomerInfo) {
                  seterrorGetRewards(true);
                }
                    
            });
        })
        
            
    }

    

    useEffect(() => {
        getYourRewards();
    }, [isOnline]);  // Indico di reindirizzare il componente quando la variabile isOnline cambia valore

    const itemTemplateReceivedAwards = (data:YourRewards) => {
        return (
          <div className="col-12 bg-white mt-2 p-0 mb-4 custom-card">
            <div className="flex flex-row">
              <div className="flex align-items-end justify-content-start p-2">
                <div className=" text-left font-bold catalogNamePrenotati">
                  {data.catalog.name}
                </div>
              </div>
            </div>
            <div className="flex flex-row">
              <img
                src={
                  process.env.REACT_APP_STORAGE_URL+`/catalogs/`+
                  data.catalog.id +
                  `/awards/` +
                  data.award.picture
                }
                style={{ borderRadius: "8px", width: "100px", height: "100px" }}
                alt={data.award.name}
              />

              <div className="p-2 pt-0">
                <div className="flex overflow-hidden">
                  <div className="flex-grow-1 flex align-items-start justify-content-start">
                    <h2 className="mt-2 mb-0">{data.award.name}</h2>
                  </div>
                </div>

                <div className="flex-grow-1 flex align-items-start justify-content-start p-1 mt-2">
                  <div style={{ color: "green" }}>
                    <div className="flex flex-row flex-wrap">
                      <div className="flex align-items-end justify-content-start ">
                        <div
                          className="text-left font-bold"
                          style={{ fontSize: "10px" }}
                        >
                          ritirato il
                        </div>
                        <div className=" ml-2 text-left font-bold">
                          {moment(data.receivedDate).format("DD/MM/YYYY HH:mm")}
                        </div>
                        {/* <div
                                        style={{ fontSize: "10px" }}
                                        className="ml-2 text-right font-bold"
                                        >
                                        AL
                                        </div> */}
                      </div>
                    </div>
                    <div className="flex flex-row flex-wrap mt-1">
                      <div className="flex align-items-center justify-content-start ">
                        <div className=" text-left font-bold text-orange-500">
                          {/* {moment(data.validTo).format("DD/MM/YYYY")} */}
                          {"-" + data.points + " punti"}
                        </div>
                        {
                          data.bookedWithContribute ? 
                          <div className=" flex align-items-center text-left font-bold ">
                            <div className='mx-3 text-orange-500'> + </div>
                            <div className='rewards-contribution' >{ data.contribute.toFixed(2) + " € " }</div>
                          </div>
                          :
                          <></>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        );
    };

    const itemTemplateBookingAwards = (data:YourRewards) => {
        return (
            <div className="col-12 bg-white mt-2 p-0 mb-4 custom-card">
                <div className="flex flex-row">
              <div className="flex align-items-end justify-content-start p-2">
                <div className=" text-left font-bold catalogNamePrenotati">
                  {data.catalog.name}
                </div>
              </div>
            </div>
                <div className="flex flex-row">
                    
                        <img src={process.env.REACT_APP_STORAGE_URL+`/catalogs/`+data.catalog.id+`/awards/`+data.award.picture} style={{ borderRadius: "8px", width: '100px', height: '100px'}} alt={data.award.name}/>
                        

                    <div className="p-2 pt-0">
                        <div className="flex overflow-hidden">
                            <div className="flex-grow-1 flex align-items-start justify-content-start">
                                <h2 className="mt-2 mb-0">{data.award.name}</h2>
                            </div>
                        </div>
                        
                            <div className="flex-grow-1 flex align-items-start justify-content-start p-1 mt-2">
                                <div style={{ color: "green" }}>
                                    <div className="flex flex-row flex-wrap">
                                    <div className="flex align-items-end justify-content-start ">
                                        <div
                                        className="text-left font-bold"
                                        style={{ fontSize: "10px" }}
                                        >
                                        prenotato il
                                        </div>
                                        <div className=" ml-2 text-left font-bold">
                                        {moment(data.bookingDate).format("DD/MM/YYYY HH:mm")}
                                        </div>
                                        {/* <div
                                        style={{ fontSize: "10px" }}
                                        className="ml-2 text-right font-bold"
                                        >
                                        AL
                                        </div> */}
                                        
                                        
                                    </div>
                                    </div>
                                    <div className="flex flex-row flex-wrap mt-1">
                                            <div className="flex align-items-center justify-content-start ">
                                                <div className=" text-left font-bold text-orange-500">
                                                    {/* {moment(data.validTo).format("DD/MM/YYYY")} */}
                                                    {"-" + data.points + ' punti'}
                                                </div>
                                                {
                                                  data.bookedWithContribute ? 
                                                  <div className=" flex align-items-center text-left font-bold ">
                                                  <div className='mx-3 text-orange-500'> + </div>
                                                  <div className='rewards-contribution' >{ data.contribute.toFixed(2) + " € " }</div>
                                                </div>
                                                  :
                                                  <></>
                                                }
                                                
                                            </div>
                                        </div>
                                </div>
                            </div> 
                            
                                
                    </div>
                </div>
            </div>
        );
    }

    const showMoreReceivedAwards = () =>{
        setRowsReceivedAwards(100); 
        setReceivedAwards(receivedAwards);
    }

    return (
        <>
          
            <div className="flex justify-content-center">
                <h2 className="mb-0 mt-2">I tuoi Premi</h2>
            </div>

            {
              errorGetRewards
              ?

              <div className="text-center text-lg mt-5">
                <div className="flex flex-column">

                      {
                        isOnline
                        ?
                        <></>
                        :
                        <div className='mb-3'>
                          <img src="./offline_globe.svg" alt="" className="img-offline-globe-empty-result"></img>
                        </div>
                        
                      }
                 
                      <div>Impossibile caricare i Premi.</div>
                      {
                          navigator.onLine
                          ?
                          <></>
                          :
                          <div>Verifica la connessione internet.</div>
                      }
                </div>
              </div>

              :
                <div className='bg-primary mb-5 mt-3 mx-1' style={{borderRadius: '6px'}} >
                  <div className="flex justify-content-between font-bold p-3" style={{cursor:'pointer'}} 
                    onClick={() => setViewBookingAwards(!viewBookingAwards)}>

                    <div className="flex align-items-center justify-content-left" style={{fontSize: '14px'}}>
                      I tuoi Premi prenotati:
                    </div>

                    <div className="flex align-items-center justify-content-right">
                      {!viewBookingAwards
                        ? <i className='pi pi-eye' style={{fontSize: '14px'}}/>
                        : <i className='pi pi-eye-slash' style={{fontSize: '14px'}}/>
                      }
                    </div>

                  </div>
              
                  { viewBookingAwards ? 
                    // <ScrollPanel style={{ width: '100%', height: bookingAwards.length > 0 ? '300px' : '25px', border: '1px solid #189cd8', borderTop: '0px' }} className="mt-1">
                    <div className="bg-white"  style={{color: 'black'}}>
                      <div className="">

                      <DataScroller 
                          value={bookingAwards} 
                          itemTemplate={itemTemplateBookingAwards} 
                          rows={100} 
                          buffer={0.4} 
                          header="" 
                          emptyMessage={
                              <div className="text-center nothing-find" style={{height: '100%'}}>
                              Non hai premi prenotati.
                              </div>
                          }/>

                      </div>
                    </div>
                    // </ScrollPanel>
                    : <></>
                  }
              
                </div>
              }

            {
              receivedAwards.length > 0
              ?
              <div className='bg-primary mb-5 mt-3 mx-1' style={{borderRadius: '6px'}} >
                <div className="flex justify-content-between font-bold p-3" style={{cursor:'pointer'}} 
                  onClick={() => setViewReceivedAwards(!viewReceivedAwards)}>
                  <div className="flex align-items-center justify-content-left" style={{fontSize: '14px'}}>
                    I tuoi Premi ritirati:
                  </div>

                  <div className="flex align-items-center justify-content-right">
                  {
                    !viewReceivedAwards
                    ? 
                    <i className='pi pi-eye' style={{fontSize: '14px'}}/>
                    : 
                    <i className='pi pi-eye-slash' style={{fontSize: '14px'}}/>
                  }
                  </div>
                </div>
              

              {/* { viewReceivedAwards ? 
                  // <ScrollPanel style={{ width: '100%', height: receivedAwards.length > 0 ? '300px' : '25px', border: '1px solid #189cd8', borderTop: '0px' }} className="mt-1">
                   <div className="bg-white" style={{color: 'black'}}>
                      <div className="">

                      <DataScroller 
                          value={receivedAwards} 
                          itemTemplate={itemTemplateReceivedAwards} 
                          rows={rowsReceivedAwards} 
                          buffer={0.4} 
                          header="" 
                          emptyMessage={
                              <div className="text-center ">
                              Non hai premi ritirati.
                              </div>
                          }/>

                      </div>
                      { receivedAwards.length > 3 && rowsReceivedAwards !== 100 ?
                          <div className='flex-column text-center p-2' onClick={() => showMoreReceivedAwards()}>
                              <div className='align-items-center justify-content-center p-2 font-bold' style={{fontSize: '1rem'}}>Mostra di più</div>
                              <div className='align-items-center justify-content-center p-2 font-bold pi pi-angle-down' style={{fontSize: '1.5rem'}}></div>
                          </div>
                          : <></>
                      }
                      
                  </div>
                  // </ScrollPanel>
                  
               : <></>
              } */}

                { viewReceivedAwards ? 
                // <ScrollPanel style={{ width: '100%', height: historyPoints.length > 0 ? '200px' : '46px', border: '1px solid #189cd8', borderTop: '0px' }} className="mt-1">
                  <div className="flex justify-content-center bg-white"  style={{color: 'black'}}>
                    <div className="flex flex-wrap align-items-center justify-content-center">

                      { receivedAwards.length > 0 ? 
                        receivedAwards.map( (item, index) => 
                              index < rowsReceivedAwards ?
                                // (<div className="flex font-bold p-3">
                                //     <div className="flex-1 align-items-center justify-content-start py-3">
                                //             {moment(item.date).format('DD/MM/YYYY HH:mm')}
                                //     </div>
                                //     <div className={ !item.isPositive ? 'flex-1 align-items-center justify-content-center px-2 py-3 text-orange-500' : 'flex-1 align-items-center justify-content-center px-2 py-3 text-green-500'}>
                                //             {item.points + ' punti'}
                                //     </div>
                                //     <div className="flex-1 align-items-center justify-content-center px-2 py-3">
                                //             {item.description}
                                //     </div>
                                // </div>)
                                itemTemplateReceivedAwards(item)
                                : index === 3 ?
                                <div className='flex-column text-center p-2' style={{cursor:'pointer'}} onClick={() => showMoreReceivedAwards()}>
                                    <div className='align-items-center justify-content-center p-2 font-bold' style={{fontSize: '1rem'}}>Mostra di più</div>
                                    <div className='align-items-center justify-content-center p-2 font-bold pi pi-angle-down' style={{fontSize: '1.5rem'}}></div>
                                </div>
                                :
                                <></> 
                              
                    )
                    : <div className='p-3 nothing-find'>Non hai premi ritirati.</div>
                }

                    </div>
                </div>
                // </ScrollPanel>
                  
              : <></>
            }
              
          </div>
          :
          <></>
            }




                



                    
        </>
    )
}
        